import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const AddressForm_Address_Fragment = graphql(`
  fragment AddressForm_Address_Fragment on Address {
    _id
    typeIds
    postalInfo {
      _id
      postOfficeBox
      postalCode
      region
      route
      streetNumber
      additional
      building
      businessPostCode {
        postalCode
        distributorOfficeNumber
      }
      locality
      inseeCode
      department
      countryAlpha2
    }
    locationInfo {
      _id
      coordinates
      projectionId
      altitude
    }
    cadastralInfo {
      _id
      departmentCode
      districtCode
      municipalityCode
      number
      oldMunicipalityCode
      section
      sheet
    }
  }
`);

export type AddressForm_Address = ResultOf<typeof AddressForm_Address_Fragment>;
